import { APIResponse } from "@/types/api";
import http from "@/composables/api";
import { MenuTreeResponse } from "@/types/interface/menu-tree";

async function getMenuTree(page = 1, limit = 10, queryParam = "") {
  let pagination = true;
  if (page == 0){
    pagination = false;
  }
  return await http.get<APIResponse<MenuTreeResponse>>(`menu-tree?is_pagination=${pagination}&page=${page}&limit=${limit}${queryParam}`);
}

async function getMenuTreeAll(page = 1, limit = 10, queryParam = "") {
  let pagination = true;
  if (page == 0){
    pagination = false;
  }
  return await http.get<APIResponse<MenuTreeResponse>>(`menu-tree-all?is_pagination=${pagination}&page=${page}&limit=${limit}${queryParam}`);
}

async function getMenuRole() {
  return await http.get<APIResponse<MenuTreeResponse>>(`menu-tree-all-permission`);
}


export default {
  getMenuTree,
  getMenuTreeAll,
  getMenuRole
};